import React, { useEffect, useRef, useState } from "react";
import api from "../../api/config";
import { useLoadScript } from "@react-google-maps/api";
import PlacesAutocomplete from "../../components/provider/AddressAutoComplete";

function GuestBasicForm({ feed, setFeed }) {
  const [propertyTypeList, setPropertyTypeList] = useState([]);
  const [loadingPropertyType, setLoadingPropertyType] = useState(false);

  const categoryRef = useRef(null);
  const propertyNameRef = useRef(null);
  const streetAddressRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);

  const [address, setAddress] = useState({
    street: feed.address1,
    city: feed.city,
    state: feed.state,
    pin: feed.pin,
  });

  const [address2, setAddress2] = useState(feed.address2 || "");
  const [selectedCategoryID, setSelectedCategoryID] = useState(feed.categoryId);
  const [propertyName, setPropertyName] = useState(feed.name);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o",
    libraries: ["places"],
  });

  // 카테고리 불러오기
  const fetchCategories = async () => {
    setLoadingPropertyType(true);
    try {
      const res = await api.get("/property-category");
      setPropertyTypeList(res.data.response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingPropertyType(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // 값 변경 핸들러
  const handleCategoryChange = (e) => {
    setSelectedCategoryID(e.target.value);
    setFeed({ ...feed, categoryId: e.target.value });
  };

  const handleNameChange = (e) => {
    setPropertyName(e.target.value);
    setFeed({ ...feed, name: e.target.value });
  };

  const handleAddress2Change = (e) => {
    setAddress2(e.target.value);
    setFeed({ ...feed, address2: e.target.value });
  };

  // PlacesAutocomplete에서 주소 선택 시 feed 업데이트
  useEffect(() => {
    setFeed({
      ...feed,
      address1: address.street,
      city: address.city,
      state: address.state,
      pin: address.pin,
    });
  }, [address]);

  return (
    <>
      <div className="col-md-9">
        <div className="m-5">
          <div className="card">
            <div className="card-body pb-0">
              {/* Property Type */}
              <div className="form-group" ref={categoryRef}>
                <label className="form-label">
                  Property Type<span className="text-danger">*</span>
                </label>
                <select
                  disabled={loadingPropertyType}
                  className="form-select"
                  value={selectedCategoryID}
                  onChange={handleCategoryChange}
                >
                  <option value="">Select</option>
                  {propertyTypeList.map((item) => (
                    <option key={item.categoryId} value={item.categoryId}>
                      {item.category}
                    </option>
                  ))}
                </select>
              </div>

              {/* Property Name */}
              <div className="form-group" ref={propertyNameRef}>
                <label className="form-label">
                  Property Name<span className="text-danger">*</span>
                </label>
                <input
                  onChange={handleNameChange}
                  value={propertyName}
                  type="text"
                  className="form-control"
                  placeholder="Property Name"
                />
              </div>

              <label className="mt-4 form-label-heading">Address</label>
            </div>

            <hr className="mr-0" />

            <div className="card-body pt-0">
              {/* Street Address */}
              <div className="form-group" ref={streetAddressRef}>
                <label className="form-label">
                  Street Address<span className="text-danger">*</span>
                </label>
                <PlacesAutocomplete
                  isLoaded={isLoaded}
                  setFormData={setAddress}
                  setSelected={() => {}}
                />
              </div>

              {/* Address2 + Zip */}
              <div className="row">
                <div className="form-group col-md-5">
                  <label className="form-label">Street Address Line 2</label>
                  <input
                    type="text"
                    value={address2}
                    onChange={handleAddress2Change}
                    className="form-control"
                    placeholder="Street Address 2"
                  />
                </div>

                <div className="form-group col-md-5">
                  <label className="form-label">Zipcode</label>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    value={address.pin}
                    placeholder="Zipcode"
                  />
                </div>
              </div>

              {/* City + State */}
              <div className="row">
                <div className="form-group col-md-5" ref={cityRef}>
                  <label className="form-label">
                    City<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={address.city}
                    className="form-control"
                    placeholder="City"
                  />
                </div>

                <div className="form-group col-md-5" ref={stateRef}>
                  <label className="form-label">
                    State<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={address.state}
                    className="form-control"
                    placeholder="State"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GuestBasicForm;